import { FormatListGroupPlusIcon } from './FormatListGroupPlusIcon';

/**
 * author: Andy Giesen
 * id 6272EE7E-4A0B-4A08-AFC4-6FD3845FAD6B
 * name format-list-group-plus
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-list-group-plus.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatListGroupAddIcon = FormatListGroupPlusIcon;
export default FormatListGroupAddIcon